import React from "react";
import { Row, Col } from "react-bootstrap";

const Heel = (props) => {
  const searchParams = new URLSearchParams(props.location.search);
  const page = searchParams.get("page") || 1;
  const pdfUrl = `https://s3-aurea-pb.s3.us-east-2.amazonaws.com/Vademecum_2020_paginado.pdf#page=${page}`;

  return (
    <div className="container">
      <Row>
        <Col xs={12}>
          <iframe
            src={pdfUrl}
            title="PDF Viewer"
            width="100%"
            height="800px"
            style={{ border: "none" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Heel;
